import { render, staticRenderFns } from "./sideSpringFrame.vue?vue&type=template&id=4d080762&scoped=true"
import script from "./sideSpringFrame.vue?vue&type=script&lang=js"
export * from "./sideSpringFrame.vue?vue&type=script&lang=js"
import style0 from "./sideSpringFrame.vue?vue&type=style&index=0&id=4d080762&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d080762",
  null
  
)

export default component.exports